module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjQiIHZpZXdCb3g9IjAgMCA0IDQiIHdpZHRoPSI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0ibTE5LjYwOCAzMS4xMjhjMCAuOTI4LS43ODQgMS43MTItMS43MjggMS43MTJzLTEuNzI4LS43ODQtMS43MjgtMS43MTJjMC0uOTQ0Ljc4NC0xLjcyOCAxLjcyOC0xLjcyOHMxLjcyOC43ODQgMS43MjggMS43Mjh6IiBmaWxsPSIjZDYwYzhjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNiAtMjkpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-current.svg
// module id = 265
// module chunks = 0